// extracted by mini-css-extract-plugin
export default {"auth_form":"authForm_auth_form__xOT5R","auth_form_title":"authForm_auth_form_title__ppU1r","auth_form_body":"authForm_auth_form_body__6Zq+m"};